import Backbone from 'backbone'
import _ from 'lodash'
import appDisplay from 'scoreboard/components/app-display'
import CalendarRangeSelector from 'scoreboard/components/calendar-range-selector'
import template from './config-widget-period.hbs'

const ConfigWidgetPeriod = Backbone.View.extend({

	/** @type {WidgetModel} */
	model: null,

	options: null,

	events: {
		'click .save': 'save'
	},

	initialize: function (options) {
		this.options = options
	},

	render: function() {
		this.$el.empty().append(template())

		let range = {
			calendarId: this.model.properties.get('calendarId')
		}

		if (_.isNil(this.model.properties.get('periodId'))) {
			range.relative = true
			range.first = range.last = (this.model.properties.get('periodDelta') || 0)
		} else {
			range.relative = false
			range.first = range.last = this.model.properties.get('periodId')
		}

		this.periodSelector = new CalendarRangeSelector({
			range: range,
			canChangeCalendar: true,
			singlePeriod: true,
			allowAppCalendar: true
		})

		this.$('.panel-content').append(this.periodSelector.el)

		this.periodSelector.render()

		return this
	},

	save: function () {
		let { first, relative, calendarId } = this.periodSelector.val()
		let update = { calendarId }

		if (relative) {
			update.periodDelta = first
			update.periodId = null
		} else {
			update.periodDelta = null
			update.periodId = first
		}

		this.options.widgetUpdater.setProperties(update)
		this.trigger('done')
	}

})

/**
 * Returns a menu option for setting the period to use for a widget's data.
 * Able to set the period for multiple widgets at once.
 *
 * @param {WidgetConfigMenu} configMenu
 */
function createConfigWidgetPeriodOption (configMenu) {
	return {
		type: 'dialog',
		label: 'report.designer.setDataSource',
		target: e => {
			let configView = new ConfigWidgetPeriod({
				model: configMenu.model,
				widgetUpdater: configMenu.options.widgetUpdater
			})

			appDisplay.dialog(configView)

			e.preventDefault()
			configMenu.trigger('done')
		}
	}
}

export default createConfigWidgetPeriodOption

createConfigWidgetPeriodOption.__filename__ = 'dashboards/widgets/create-config-widget-period-option.js'
